export default "__VITE_ASSET__uj0Ftoyx__"